<template>
  <div>
    <input
      type="checkbox"
      :id="'toggle' + id"
      v-model="isChecked"
      @change="updateValue"
    />
    <label :for="'toggle' + id">Toggle</label>
  </div>
</template>

<script>
export default {
  props: {
    id: Number,
    fieldKey: String,
    fieldValue: Boolean,
  },
  computed: {
    isChecked: {
      get() {
        return this.fieldValue;
      },
      set(value) {
        this.$emit("update:fieldValue", { key: this.fieldKey, value });
      },
    },
  },
  methods: {
    updateValue() {
      this.isChecked = !this.isChecked;
    },
  },
};
</script>
<style scoped>
input[type="checkbox"] {
  height: 0;
  width: 0;
  display: none;
}

label {
  cursor: pointer;
  text-indent: -9999px;
  width: 30px;
  height: 18px;
  background: #e5e7eb;
  display: block;
  border-radius: 100px;
  position: relative;
}

label:after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 14px;
  height: 14px;
  background: #fff;
  border-radius: 90px;
  transition: 0.3s;
}

input:checked + label {
  background: #3056d3;
}

input:checked + label:after {
  left: calc(100% - 2px);
  transform: translateX(-100%);
}
</style>
